/**
 * The contracts tab: the list of contracts, or one contract's page.
 *
 * Which contract is open is URL state (`?doc=<id>`), the same rule the
 * invoices and quotes tabs follow. A contract used to open in a dialog with the
 * text in a 45%-height scroll box and the signature pad under it - a client
 * signed something they had read through a slot. As a page the text has the
 * width and the length it was written with, and the signature sits beside it.
 */
import { useSearchParams } from "react-router-dom";
import { keepPreview } from "../../../lib/previewMode";
import { ContractList } from "./ContractList";
import { ContractPage } from "./ContractPage";

export function ContractsSection() {
  const [params, setParams] = useSearchParams();
  const docId = params.get("doc");

  // Every rewrite goes through `keepPreview`: `setParams` replaces the whole
  // query string, and a staff preview would otherwise drop its token.
  const open = (id: string) => setParams(keepPreview({ tab: "contracts", doc: id }));
  const back = () => setParams(keepPreview({ tab: "contracts" }));

  if (docId) return <ContractPage key={docId} id={docId} onBack={back} />;
  return <ContractList onOpen={open} />;
}
